import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  SIGNIN,
  MECOMPANIES,
  USERS,
  WELCOME,
  COMPANIES,
  COMPANYMETRICS,
  COMPANYREPORTS,
  COMPANYIMPORT,
  COMPANYSETTINGS,
} from './routes';

export function useNavigationCore() {
  const navigate = useNavigate();

  const goToSignIn = useCallback(() => {
    navigate(SIGNIN);
  }, [navigate]);

  const goToWelcome = useCallback(() => {
    navigate(WELCOME);
  }, [navigate]);

  const goToMeCompanies = useCallback(() => {
    navigate(MECOMPANIES);
  }, [navigate]);

  const goToCompanyMetrics = useCallback(
    (id: string) => {
      navigate(`${COMPANYMETRICS}/${id}`);
    },
    [navigate]
  );

  const goToCompanyReports = useCallback(
    (id: string) => {
      navigate(`${COMPANYREPORTS}/${id}`);
    },
    [navigate]
  );

  const goToCompanySettings = useCallback(
    (id: string) => {
      navigate(`${COMPANYSETTINGS}/${id}`);
    },
    [navigate]
  );

  const goToCompanyImport = useCallback(
    (id: string) => {
      navigate(`${COMPANYIMPORT}/${id}`);
    },
    [navigate]
  );

  const goToUsers = useCallback(() => {
    navigate(USERS);
  }, [navigate]);

  const goToUser = useCallback(
    (id: string) => {
      navigate(`${USERS}/${id}`);
    },
    [navigate]
  );

  const goToCompanies = useCallback(() => {
    navigate(COMPANIES);
  }, [navigate]);

  const goToCompany = useCallback(
    (id: string) => {
      navigate(`${COMPANIES}/${id}`);
    },
    [navigate]
  );

  return {
    goToSignIn,
    goToWelcome,
    goToMeCompanies,
    goToCompanyMetrics,
    goToCompanyReports,
    goToCompanySettings,
    goToCompanyImport,
    goToUsers,
    goToUser,
    goToCompanies,
    goToCompany,
  };
}
